<template>
  <div
    class="z-border-red"
    style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
  >
    <v-layout>
      <v-flex>
        <div style="padding-left: 10px; word-break: break-all">
          {{ product.name }}
        </div>
      </v-flex>

      <v-flex shrink>
        <v-btn
          small
          depressed
          color="primary"
          @click="$emit('handleSelectProduct')"
          :disabled="hasSelected"
        >
          {{ hasSelected ? $t('Selected') : $t('Select') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ['product', 'exactProductIds'],
  computed: {
    hasSelected() {
      return (
        this.exactProductIds &&
        this.exactProductIds.findIndex((product) => {
          return this.product.id == product.id
        }) != -1
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/coupon/ProductItem.vue